import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formContainer: {
      paddingTop: "7vh",
      paddingBottom: "5vh",
      maxWidth: "100%",
      display: "flex",
      borderRadius: 20,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "10vh",
      [theme.breakpoints.down("sm")]: {
        width: "75vw",
      },
      [theme.breakpoints.up("md")]: {
        width: "40rem",
      },
    },
    form: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    textField: {
      width: "30rem",
      marginBottom: "2vh",
      [theme.breakpoints.down("sm")]: {
        width: "65vw",
      },
    },
  }),
);

const fields = [
  {
    name: "username",
    type: "text",
    label: "Nome",
  },
  {
    name: "email",
    type: "email",
    label: "Email",
  },
];

const useContactForm = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const [t] = useTypedTranslations();

  const onSubmit = useMemo(() => {
    // TODO: Store data somewhere
  }, []);

  return {
    styles,
    classes,
    atomicStyles,
    t,
    fields,
    onSubmit,
  };
};

export { useContactForm as default };
